/**
 * TanStack Router のルート定義
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business creative web のルート定義。Overview・Brand Core・Principles・Checklist・Colors・Fonts・Judgment・AI Handoff・Prompts・Review Examples・History・Settings を提供する。
 * @graph-connects none
 */
import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { RootLayout } from './components/app-layout.js';
import { AiHandoffPage } from './pages/ai-handoff-page.js';
import { BrandCorePage } from './pages/brand-core-page.js';
import { ChecklistPage } from './pages/checklist-page.js';
import { ColorsPage } from './pages/colors-page.js';
import { Dashboard } from './pages/dashboard.js';
import { FontsPage } from './pages/fonts-page.js';
import { HistoryPage } from './pages/history-page.js';
import { JudgmentPage } from './pages/judgment-page.js';
import { PrinciplesPage } from './pages/principles-page.js';
import { PromptsPage } from './pages/prompts-page.js';
import { ReviewExamplesPage } from './pages/review-examples-page.js';
import { SettingsPage } from './pages/settings-page.js';

/** ルートルート。 */
/** @graph-connects none */
const rootRoute = createRootRoute({ component: RootLayout });

/** 各ページのルート定義。 @graph-connects none */
const routes = [
  createRoute({ getParentRoute: () => rootRoute, path: '/', component: Dashboard }),
  createRoute({ getParentRoute: () => rootRoute, path: '/brand-core', component: BrandCorePage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/principles', component: PrinciplesPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/checklist', component: ChecklistPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/colors', component: ColorsPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/fonts', component: FontsPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/judgment', component: JudgmentPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/ai-handoff', component: AiHandoffPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/prompts', component: PromptsPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/review-examples',
    component: ReviewExamplesPage,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/history', component: HistoryPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/settings', component: SettingsPage }),
];

/** ルートツリー。 */
/** @graph-connects none */
const routeTree = rootRoute.addChildren(routes);

/**
 * アプリケーションルーター。
 * @graph-connects none
 */
export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  /** ルーター型をアプリ全体に登録する。 */
  interface Register {
    router: typeof router;
  }
}
